import React from 'react';

import { PdfIcon } from '../../static';

import './styles.scss';

const Document = ({document, ...props }) => {
	const position = document.position ? document.position : '';
	return (
		<div className="document">	
			<div className="document__icon">
            	<PdfIcon />
			</div>
            <div className="document__description">
                <div className="document__description-added">
                    {`Added by: ${position} ${document.authorFullName}`}
                </div>
                <div className="document__description-name">
                    {`Patient: ${document.patientFullName}`}
                </div>
                <div className="document__description-title">
					{document.title}
				</div>
            </div>
		</div>
	)
};

export default Document;
